import { render } from "./Culture.vue?vue&type=template&id=3bf99010&scoped=true"
import script from "./Culture.vue?vue&type=script&lang=js"
export * from "./Culture.vue?vue&type=script&lang=js"

import "./Culture.vue?vue&type=style&index=0&id=3bf99010&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf99010"]])

export default __exports__